module.exports = __webpack_public_path__ + "img/arrow_left_2.85160150.svg";